export default __webpack_public_path__ + "static/assets/c97b97c8068bfaae40cba68f4ac4a6d6.svg";